/**
 * goToQuiz.js
 * Written by: Alex Kasemir
 */

import alertActions from 'store/alert/actions';
import { selectQuiz } from '../selectQuiz';
import quizActions from '../../../quiz/actions';

/**
 * Description of the goToQuiz action
 */

export const goToQuiz = (id) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve) => {
      dispatch(selectQuiz(id));
      await dispatch(quizActions.resetSession(Boolean(getState().user.JWT)));
      const response = await dispatch(quizActions.getQuizResults(id));
      const hasAttempted = Boolean(response.data.attempted && response.data.attempted > 0);
      dispatch(quizActions.getQuiz(id, hasAttempted))
        .then((quiz) => {
          if (quiz.questions.length !== 0) {
            resolve(`/question/${quiz.questions[0]}`);
          } else {
            if (getState().user.JWT) {
              resolve(`/quiz/${id}/results`);
            } else {
              resolve(`/`);
            }
            dispatch(alertActions.createAlert({
              message: `This quiz is out of questions.`,
              type: `danger`,
            }));
          }
        });
    });
  };
};

export default goToQuiz;
